import { Container, Row, Col, Card, Button, Image } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

// React Icons
import {
  FaUsers, FaBook, FaChartLine, FaHandshake,
  FaLaptopCode, FaChalkboardTeacher, FaHandsHelping,
  FaCertificate, FaStar, FaQuoteLeft, FaArrowRight
} from "react-icons/fa";
import {
  SiReact, SiNodedotjs, SiMongodb, SiPython,
  SiTensorflow, SiOpenjdk as SiJava, SiMysql, SiFirebase
} from "react-icons/si";

const Home = () => {
  const navigate = useNavigate();
  const [reviews, setReviews] = useState([]);
  const [expanded, setExpanded] = useState({});

  const toggleExpand = (index) => {
    setExpanded(prev => ({ ...prev, [index]: !prev[index] }));
  };

  useEffect(() => {
    fetch("https://skillsuprise.com/get-reviews.php?limit=3")
      .then(res => res.json())
      .then(data => {
        if (data.status === "success") {
          setReviews(data.data);
        }
      })
      .catch(err => console.error(err));
  }, []);

  const handleStartExam = () => {
    const session = localStorage.getItem("session_id");
  
    if (!session) {
      navigate("/signup");
    } else {
      navigate("/enter-code");
    }
  };

  return (
    <div style={{ fontFamily: "'Inter', 'Poppins', system-ui, sans-serif" }}>

      {/* HERO SECTION - closely matched */}
      <section style={{ background: "linear-gradient(135deg,#eef6ff,#dff1ff)", padding: "100px 0" }}>
  <Container>
    <Row className="align-items-center">

      {/* LEFT */}
      <Col lg={6}>
        <span className="badge bg-light text-primary mb-3">
          #1 EdTech Exam & Training Platform
        </span>

        <h1 className="fw-bold display-4">
          Become <span style={{ color: "#0d6efd" }}>Industry Ready</span> with Skills Uprise
        </h1>

        <p className="text-muted mt-3">
          Master in-demand skills through real-time projects, expert mentorship,
          and industry-recognized certifications.
        </p>

        <div className="d-flex gap-3 mt-4">
          <Button className="btn-gradient px-4 py-2" onClick={handleStartExam}>
            Start Assessment
          </Button>


          <Button variant="light" className="px-4 py-2 shadow-sm" onClick={() => navigate("/courses")}>
            Explore Courses →
          </Button>

        </div>
      </Col>

      {/* RIGHT */}
      <Col lg={6} className="position-relative mt-5 mt-lg-0">
        <img
          src="https://images.pexels.com/photos/6804080/pexels-photo-6804080.jpeg"
          style={{
            width: "100%",
            borderRadius: "20px",
            boxShadow: "0 20px 50px rgba(0,0,0,0.2)"
          }}
        />

        {/* FLOATING BADGES */}
        <div className="floating-badge" style={{ top: "10%", right: "10%" }}>
          ⭐ Certified
        </div>

        <div className="floating-badge" style={{ bottom: "10%", left: "10%" }}>
          <strong>95%</strong> Placement
        </div>
      </Col>

    </Row>
  </Container>
</section>

      {/* TRUSTED BY */}
      <section className="py-5 bg-white border-bottom">
        <Container className="text-center">
          <p className="text-muted fw-medium mb-4" style={{ fontSize: "1.1rem" }}>
            TRUSTED BY
          </p>
          <div className="d-flex justify-content-center gap-5 flex-wrap fw-semibold" style={{ fontSize: "1.3rem", color: "#495057" }}>
            <span>Google</span>
            <span>Microsoft</span>
            <span>Amazon</span>
            <span>TCS</span>
            <span>Infosys</span>
            <span>Wipro</span>
          </div>
        </Container>
      </section>

      {/* STATS - matched your requested circular icon style */}
      <section className="py-5">
  <Container>
    <Row className="g-4 text-center">

      {[
        { icon: <FaUsers />, num: "5,000+", label: "Students" },
        { icon: <FaBook />, num: "50+", label: "Courses" },
        { icon: <FaChartLine />, num: "95%", label: "Placement" },
        { icon: <FaHandshake />, num: "120+", label: "Partners" }
      ].map((item, i) => (
        <Col md={3} key={i}>
          <div className="glass p-4 hover-lift">
            <div className="text-primary fs-3 mb-2">{item.icon}</div>
            <h3 className="fw-bold">{item.num}</h3>
            <p className="text-muted">{item.label}</p>
          </div>
        </Col>
      ))}

    </Row>
  </Container>
</section>

      {/* <style>{`
        .stats-card:hover {
          transform: translateY(-12px);
          box-shadow: 0 25px 50px -12px rgba(0,0,0,0.15) !important;
        }
        .stats-card:hover .text-primary {
          color: #0056b3 !important;
        }
      `}</style> */}

      {/* HOW WE TRAIN - large image left, cards right with arrow icon */}
      <section className="py-5 bg-light">
        <Container>
          <div className="text-center mb-5">
            <h6 className="text-primary fw-bold mb-2">OUR METHODOLOGY</h6>
            <h2 className="fw-bold mb-3" style={{ fontSize: "2.8rem" }}>How We Train Students</h2>
            <p className="text-muted" style={{ maxWidth: "700px", margin: "0 auto", fontSize: "1.2rem" }}>
              Our proven 3-pillar methodology transforms beginners into industry-ready professionals
            </p>
          </div>
          <Row className="align-items-center g-5">
            <Col lg={6}>
              <Image
                src="https://images.pexels.com/photos/4218883/pexels-photo-4218883.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                fluid
                rounded
                className="shadow-lg"
                alt="Training session"
              />
            </Col>
            <Col lg={6}>
              <div className="d-flex flex-column gap-4">
                {[
                  { icon: FaLaptopCode, title: "Real-time Projects", desc: "Work on live industry projects that solve actual business problems." },
                  { icon: FaChalkboardTeacher, title: "Industry Mentorship", desc: "Learn directly from senior engineers at top tech companies." },
                  { icon: FaHandsHelping, title: "Hands-on Labs", desc: "Practice in sandboxed environments with instant feedback." },
                ].map((item, i) => (
                  <Card key={i} className="glass hover-lift mb-3">
                    <Card.Body className="d-flex align-items-center">
                      <div className="me-4">
                      <FaLaptopCode size={35} className="text-primary me-3" />
                      </div>
                      <div>
                        <h5 className="fw-bold mb-1" style={{ fontSize: "1.4rem" }}>{item.title}</h5>
                        <p className="text-muted" style={{ fontSize: "1.05rem" }}>{item.desc}</p>
                      </div>
                      <FaArrowRight className="ms-auto text-primary" size={24} />
                    </Card.Body>
                  </Card>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* PROJECTS SHOWCASE - keep as is but adjust spacing/fonts */}
      <section className="py-5">
        <Container>
          <div className="text-center mb-5">
            <h6 className="text-primary fw-bold mb-2">PORTFOLIO</h6>
            <h2 className="fw-bold mb-3" style={{ fontSize: "2.8rem" }}>Projects Showcase</h2>
            <p className="text-muted" style={{ fontSize: "1.2rem" }}>Real-world projects built by our students</p>
          </div>
          <Row className="g-4">
            {[
              { icon: SiReact, title: "E-Commerce Platform", desc: "Full-featured marketplace with payments", stack: "React + Node.js + MongoDB" },
              { icon: SiPython, title: "AI Chatbot System", desc: "Customer support with sentiment analysis", stack: "Python + TensorFlow + NLP" },
              { icon: SiJava, title: "Hospital Management", desc: "Appointment booking system", stack: "Java + Spring Boot + MySQL" },
              { icon: SiReact, title: "IoT Dashboard", desc: "Real-time device monitoring system", stack: "React + MQTT + Firebase" },
            ].map((proj, i) => (
              <Col md={3} key={i}>
                <Card className="glass hover-lift text-center p-3">
                  <Card.Body >
                  <SiReact size={40} className="text-primary mb-2" />
                    <h6 className="fw-bold " style={{ fontSize: "1.35rem" }}>{proj.title}</h6>
                    <p className="text-muted mb-3" style={{ fontSize: "1rem" }}>{proj.desc}</p>
                    <small className="text-muted" style={{ fontSize: "0.95rem" }}>{proj.stack}</small>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
          <div className="text-center mt-5">
            <Button variant="primary" size="lg" className="px-5 py-3 rounded-pill fw-bold" onClick={() => navigate("/projects")}>
              View All Projects →
            </Button>
          </div>
        </Container>
      </section>

      {/* INTERNSHIP OPPORTUNITIES - image left, text + bullets right, stats below image */}
      <section className="py-5 bg-light">
        <Container>
          <Row className="align-items-center g-5">
            <Col lg={6}>
              <Image
                src="https://images.pexels.com/photos/340152/pexels-photo-340152.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                fluid
                rounded
                className="shadow-lg"
                alt="Developer at work"
              />
              <Row className="g-3 mt-4">
                {[
                  { num: "25+", label: "Active Internships" },
                  { num: "50+", label: "Partner Companies" },
                  { num: "2,000+", label: "Students Placed" },
                  { num: "₹15K/mo", label: "Avg Stipend" },
                ].map((s, i) => (
                  <Col sm={6} key={i}>
                    <Card className="text-center border-0 shadow-sm py-3">
                      <Card.Body>
                        <h4 className="fw-bold text-primary mb-1">{s.num}</h4>
                        <p className="mb-0 text-muted">{s.label}</p>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Col>
            <Col lg={6}>
              <h6 className="text-primary fw-bold mb-2">CAREER LAUNCH</h6>
              <h2 className="fw-bold mb-3" style={{ fontSize: "2.8rem" }}>Internship Opportunities</h2>
              <p className="text-muted mb-4" style={{ fontSize: "1.15rem" }}>
                Get real industry experience with structured internship programs at India's top tech companies.
              </p>
              <ul className="list-unstyled mb-5" style={{ fontSize: "1.1rem" }}>
                <li className="mb-3"><strong style={{ color: "#198754" }}>●</strong> Paid internships at partner companies</li>
                <li className="mb-3"><strong style={{ color: "#198754" }}>●</strong> 3-6 month structured programs</li>
                <li className="mb-3"><strong style={{ color: "#198754" }}>●</strong> Mentorship from senior engineers</li>
                <li><strong style={{ color: "#198754" }}>●</strong> PPO opportunities on performance</li>
              </ul>
              <Button variant="success" size="lg" className="px-5 py-3 rounded-pill fw-bold" onClick={() => navigate("/internships")}>
                Explore Internships
              </Button>
            </Col>
          </Row>
        </Container>
      </section>

      {/* CERTIFICATIONS - keep similar but match spacing */}
      <section className="py-5">
        <Container>
          <Row className="align-items-center g-5 flex-lg-row-reverse">
            <Col lg={6}>
              <Image
                src="https://test-bloom-pro.lovable.app/assets/certification-premium-D06Q2YxQ.jpg"
                fluid
                rounded
                className="shadow-lg"
                alt="Certificate"
              />
            </Col>
            <Col lg={6}>
              <h6 className="text-primary fw-bold mb-2">CREDENTIALS</h6>
              <h2 className="fw-bold mb-3" style={{ fontSize: "2.8rem" }}>Industry-Recognized Certifications</h2>
              <p className="text-muted mb-4" style={{ fontSize: "1.15rem" }}>
                Stand out with credentials that employers trust and value
              </p>
              <Row className="g-4">
                {[
                  { icon: FaCertificate, title: "Industry Recognized", desc: "Accepted by 500+ companies worldwide" },
                  { icon: FaCertificate, title: "Verified & Secure", desc: "Unique ID & QR code on every certificate" },
                  { icon: FaStar, title: "Career Boost", desc: "Stand out with proven credentials" },
                  { icon: FaHandshake, title: "Resume Builder", desc: "Add verified badges to LinkedIn & resume" },
                ].map((b, i) => (
                  <Col md={6} key={i}>
                    <Card className="border-0 shadow-sm h-100 text-center py-4">
                      <Card.Body>
                        <b.icon size={50} className="text-primary mb-3" />
                        <h5 className="fw-bold mb-2">{b.title}</h5>
                        <p className="text-muted small mb-0">{b.desc}</p>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
              <div className="mt-5">
                <Button variant="primary" size="lg" className="px-5 py-3 rounded-pill fw-bold" onClick={() => navigate("/certifications")}>
                  View Certifications →
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Testimonials & CTA remain unchanged as per your request */}
      <section className="py-5 bg-light">
        <Container>
          <h2 className="text-center fw-bold mb-5" style={{ fontSize: "2.8rem" }}>What Our Students Say</h2>
          <Row className="g-4">
            {reviews.map((item, index) => (
              <Col md={4} key={index}>
                <Card className="border-0 shadow h-100">
                  <Card.Body className="p-4">
                    <FaQuoteLeft size={40} className="text-primary mb-3 opacity-50" />
                    <p className="fst-italic" style={{ position: "relative" }}>
                      {expanded[index]
                        ? `"${item.review}"`
                        : `"${item.review.substring(0, 180)}${item.review.length > 180 ? "..." : ""}"`
                      }
                      {item.review.length > 180 && (
                        <span
                          onClick={() => toggleExpand(index)}
                          style={{ color: "#0d6efd", cursor: "pointer", marginLeft: "6px", fontWeight: "500" }}
                        >
                          {expanded[index] ? "Less" : "More"}
                        </span>
                      )}
                    </p>
                    <div className="mt-4 d-flex align-items-center">
                      <img
                        src={item.profile_pic}
                        alt={item.name}
                        style={{ width: "50px", height: "50px", borderRadius: "50%", objectFit: "cover", marginRight: "15px" }}
                      />
                      <div>
                        <strong>{item.name}</strong>
                        <div className="text-warning mt-1">
                          {"★".repeat(Math.round(item.rating))}
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="py-5 text-white text-center" style={{ background: "linear-gradient(90deg, #0d6efd, #198754)" }}>
        <Container>
          <h2 className="fw-bold mb-4" style={{ fontSize: "3rem" }}>Take Your Assessment Test Now</h2>
          <p className="lead mb-4" style={{ fontSize: "1.4rem" }}>
            Prove your skills and get certified. Start your exam today.
          </p>
          <Button
            variant="light"
            size="lg"
            className="px-5 py-3 fw-bold rounded-pill"
            style={{ fontSize: "1.3rem" }}
            onClick={() => navigate("/enter-code")}
          >
            Start Exam Now
          </Button>
        </Container>
      </section>

    </div>
  );
};

export default Home;